
import Vue from 'vue'

export default Vue.extend({
   name: 'PromoteSubscription',
   computed: {
      visible(): boolean {
         return this.$store.state.modelData.PromoteSubscription
      },
   },
})
